import { useCallback } from "react";
import useApiClient from "../services/axiosInstance";

export const useAccountAggregator = () => {
  const { api } = useApiClient();
  const startJouenry = useCallback(
    async (data) => {
      try {
        const response = await api.post(
          "/api/accountAggregator/getJourney",
          data,
        );
        return response.data;
      } catch (error) {
        return "Please try again later";
      }
    },
    [api],
  );

  const getResult = useCallback(
    async (data) => {
      try {
        const response = await api.post("/api/accountAggregator/result", data);
        return response.data;
      } catch (error) {
        return null;
      }
    },
    [api],
  );
  const startPolling = useCallback(
    async (data) => {
      try {
        const response = await api.post("/api/accountAggregator/status", data);
        return response.data;
      } catch (error) {
        return null;
      }
    },
    [api],
  );

  return { startJouenry, startPolling, getResult };
};
